import type { WorkflowAutomationActionType } from '../models/automation-api.models';

/** Contrato API — int em `actions[].type` (1–6 no MVP atual). */
const CONTRACT_ACTION_TO_INT: Record<
  | 'MoveCardToStage'
  | 'CreateCardComment'
  | 'AssignUserToCard'
  | 'SendWhatsAppTemplate'
  | 'SendEmailTemplate'
  | 'UpdateCardField'
  | 'SetCardDueDate'
  | 'SendAppNotification'
  | 'SendWhatsAppSessionMessage',
  number
> = {
  MoveCardToStage: 1,
  CreateCardComment: 2,
  AssignUserToCard: 3,
  SendWhatsAppTemplate: 4,
  UpdateCardField: 5,
  SetCardDueDate: 6,
  SendEmailTemplate: 7,
  SendAppNotification: 8,
  SendWhatsAppSessionMessage: 9,
};

const ACTION_TYPE_FROM_INT: Record<number, WorkflowAutomationActionType> = {
  1: 'MoveCardToStage',
  2: 'CreateCardComment',
  3: 'AssignUserToCard',
  4: 'SendWhatsAppTemplate',
  5: 'UpdateCardField',
  6: 'SetCardDueDate',
  7: 'SendEmailTemplate',
  8: 'SendAppNotification',
  9: 'SendWhatsAppSessionMessage',
};

const ACTION_NAME_NORMALIZED: Record<string, WorkflowAutomationActionType> = {
  movecardtostage: 'MoveCardToStage',
  createcardcomment: 'CreateCardComment',
  assignusertocard: 'AssignUserToCard',
  sendwhatsapptemplate: 'SendWhatsAppTemplate',
  sendemailtemplate: 'SendEmailTemplate',
  updatecardfield: 'UpdateCardField',
  setcardduedate: 'SetCardDueDate',
  createcard: 'CreateCard',
  sendappnotification: 'SendAppNotification',
  sendwhatsappsessionmessage: 'SendWhatsAppSessionMessage',
};

export function workflowAutomationActionTypeToApiInt(type: WorkflowAutomationActionType): number {
  const n = CONTRACT_ACTION_TO_INT[type as keyof typeof CONTRACT_ACTION_TO_INT];
  if (typeof n === 'number') return n;
  return 1;
}

export function normalizeWorkflowAutomationActionTypeFromApi(raw: unknown): WorkflowAutomationActionType {
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    const mapped = ACTION_TYPE_FROM_INT[Math.trunc(raw)];
    if (mapped) return mapped;
  }
  const s = typeof raw === 'string' ? raw.trim() : '';
  if (!s) return 'MoveCardToStage';
  const compact = s.toLowerCase().replace(/_/g, '');
  const fromName = ACTION_NAME_NORMALIZED[compact];
  if (fromName) return fromName;
  if (/^[A-Za-z]+$/.test(s) && s[0] === s[0].toUpperCase()) {
    return s as WorkflowAutomationActionType;
  }
  return 'MoveCardToStage';
}
